"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasUniformInputFieldTypes = void 0;
function hasUniformInputFieldTypes(...typesList) {
    if (typesList.length < 2) {
        return true;
    }
    const [template] = typesList;
    for (let i = 1; i < typesList.length; i++) {
        const types = typesList[i];
        if (template.length !== types.length) {
            return false;
        }
        for (const type of types) {
            if (!template.includes(type)) {
                return false;
            }
        }
    }
    return true;
}
exports.hasUniformInputFieldTypes = hasUniformInputFieldTypes;
